module.exports = __webpack_public_path__ + "media/svg/CheckSquareFil-black-028222d6.svg";